const LocaleAbbreviation = (locale) => {
	const abbreviation = {
		'en-US': 'US',
		'en-GB': 'GB',
		'fr-FR': 'FR',
		'fr-CA': 'CA',
		'es-ES': 'ES',
		'de-DE': 'DE',
		'en-CA': 'CA',
		'en-AU': 'AU',
	}
	return(abbreviation[locale] || locale);
};

export  default LocaleAbbreviation;
